<template>
    <div class="zebra-crossing-detail">
        <!-- 处理明细 -->
        <el-form>
            <div class="zebra-item">
                <div class="zebra-item_tit">服务信息</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="状态：">{{ detail.status | tableVal(eventStatus) }}</el-form-item>
                    </el-col>
                    <el-col :span="12">

                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="主办人：">{{ detail.requester }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="当前处理人：">{{ detail.currentHandler }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="解决人：">{{ detail.solutionUser }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="服务组：">{{ detail.currentDepartment }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="参与处理的人员：">
                            <span v-for="item in detail.participant" style="margin-right: 10px;">{{item}}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="解决时间：">{{ detail.solutionTime }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="创建人：">{{ detail.createUser }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="请求人：">{{ detail.requester }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="更新人：">{{ detail.updateUser }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="更新时间：">{{ detail.updateTime }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="创建时间：">{{ detail.createTime }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="关闭时间：">{{ detail.closeTime }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="指定响应时间：">{{ detail.plannedResponseTime }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="指定完成时间：">{{ detail.plannedCompleteTime }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="实际响应时间：">{{ detail.actualResponseTime }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实际完成时间：">{{ detail.actualCompleteTime }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="挂起标识：">{{ detail.suspend | tableVal(suspend)  }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="挂起时间：">{{ detail.suspendTime }}</el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="zebra-item">
                <div class="zebra-item_tit">SLA信息</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="SLA达标：">{{ detail.slaStandard | tableVal(slaStandard) }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="SLA状态：">{{ detail.slaStatus | tableVal(slaStatus)  }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="服务合同：">{{ detail.toSla[0].contract.title }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="服务水平协议：">{{ detail.toSla[0].title }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="目标响应时长：">{{ detail.plannedResponseDuration }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="目标完成时长：">{{ detail.plannedCompleteDuration }}</el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            detail:Object
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            eventStatus(){
                return this.dictionary.event_status;
            },
            suspend(){
                return this.dictionary.suspend;
            },
            slaStatus(){
                return this.dictionary.sla_status;
            },
            slaStandard(){
                return this.dictionary.sla_standard;
            },


        },
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
